<template>
    <div class="bo-login">
        <form
            id="post-form"
            class="needs-validation"
            novalidate
            @submit.prevent="triggerAction"
        >
            <div class="login-wrapper">
                <div class="header-content">
                    <div class="company-logo">
                        <img
                            :src="siteLogoUrl"
                            alt="Logo"
                        />
                    </div>
                </div>

                <div class="body-content">
                    <div
                        id="welcome-title"
                        class="title"
                        v-show="isPnpFood && actionText != 'Forget-Password'"
                        v-html="'歡迎來到東遠國際餐飲訂貨平台</br>Welcome to the P&P Food Ordering Platform'"
                    ></div>

                    <div
                        class="bottom-div"
                        :style="isMobileViewport ? 'flex-direction: column;' : ''"
                    >
                        <div
                            class="left-panel"
                            :class="actionText == 'Open-Mail' ? ' expanded' : ''"
                            :style="isPnpFood && actionText != 'Open-Mail' ? 'align-self: flex-start;' : ''"
                        >
                            <div
                                class="title"
                                v-if="actionText == 'Forget-Password'"
                            >
                                {{ loginTranslations.forgot_your_password ?? "Forget Your Password?" }}
                            </div>
                            <div
                                class="title"
                                v-if="actionText == 'Reset-Password'"
                            >
                                {{ loginTranslations.reset_your_password ?? "Reset Your Password" }}
                            </div>
                            <div
                                class="title"
                                v-if="actionText == 'Open-Mail'"
                            >
                                {{ loginTranslations.check_your_email ?? "Check Your Email" }}
                            </div>
                            <div
                                class="title"
                                v-else-if="!isPnpFood"
                            >
                                {{ titleText }}
                            </div>
                            <div
                                class="subtitle"
                                v-if="actionText == 'Login' && !isPnpFood"
                                v-html="loginTranslations.login_to_continue ?? 'Please login to continue'"
                            ></div>
                            <div
                                class="subtitle"
                                v-else-if="actionText == 'Register' && !isPnpFood"
                            >
                                {{ loginTranslations.take_one_minute ?? "It will take just 1 min" }}
                            </div>
                            <div
                                class="subtitle"
                                v-else-if="actionText == 'Forget-Password'"
                            >
                                {{
                                    loginTranslations.enter_email_address_reset_password ??
                                    "Enter your e-mail address and we'll send you a link to reset your password"
                                }}
                            </div>
                            <div
                                class="subtitle"
                                v-else-if="actionText == 'Reset-Password'"
                            >
                                {{
                                    loginTranslations.enter_new_password_customer ??
                                    "Enter your new password for your account."
                                }}
                            </div>
                            <div
                                class="subtitle"
                                v-else-if="actionText == 'Open-Mail'"
                            >
                                {{ loginTranslations.email_sent ?? "We sent an email to you at" }}
                                <span class="email"> {{ email }}</span
                                >{{
                                    loginTranslations.magic_link ?? ". It has a magic link that'll reset your password."
                                }}
                            </div>
                            <div
                                class="login-svg"
                                v-if="actionText === 'Login'"
                                :style="isPnpFood ? (isMobileViewport ? 'padding-top: 0px' : 'padding-top: 48px') : ''"
                            >
                                <div v-if="isPnpFood">
                                    <img
                                        :src="
                                            isMobileViewport
                                                ? '/assets/graphics/login_image_4_3.png'
                                                : '/assets/graphics/login_image_4_3_large.png'
                                        "
                                        alt="image"
                                        style="display: block; max-width: 100%; height: auto"
                                    />
                                </div>
                                <!-- 345 257
                                624 468 -->
                                <bo-svg
                                    v-else
                                    :svg-content="loginTranslations.img_login_path ?? '/assets/graphics/img-login.svg'"
                                    :primary-color="primaryColor"
                                    :width="200"
                                    :height="200"
                                ></bo-svg>
                            </div>
                            <div
                                class="register-svg"
                                v-if="actionText === 'Register'"
                                :style="isPnpFood ? (isMobileViewport ? 'padding-top: 0px' : 'padding-top: 48px') : ''"
                            >
                                <div v-if="isPnpFood">
                                    <img
                                        :src="
                                            isMobileViewport
                                                ? '/assets/graphics/login_image_4_3.png'
                                                : '/assets/graphics/login_image_4_3_large.png'
                                        "
                                        alt="image"
                                        style="display: block; max-width: 100%; height: auto"
                                    />
                                </div>
                                <bo-svg
                                    v-else
                                    :svg-content="
                                        loginTranslations.img_register_path ?? '/assets/graphics/img-register.svg'
                                    "
                                    :primary-color="primaryColor"
                                    :width="200"
                                    :height="200"
                                ></bo-svg>
                            </div>
                            <div
                                class="forgotpassword-svg"
                                v-if="actionText === 'Forget-Password'"
                                style="padding-top: 24px"
                            >
                                <bo-svg
                                    :svg-content="
                                        isPnpFood
                                            ? '/assets/graphics/img-forgot-password-tc.svg'
                                            : loginTranslations.img_resetpassword_path ??
                                              '/assets/graphics/img-resetpassword.svg'
                                    "
                                    :primary-color="primaryColor"
                                    :width="200"
                                    :height="200"
                                ></bo-svg>
                            </div>
                            <div
                                class="resetpassword-svg"
                                v-if="actionText === 'Reset-Password'"
                            >
                                <bo-svg
                                    :svg-content="'/assets/graphics/img-forgot-password-tc.svg'"
                                    :primary-color="primaryColor"
                                    :width="200"
                                    :height="200"
                                ></bo-svg>
                            </div>
                            <div
                                class="Mail-svg"
                                v-if="actionText === 'Open-Mail'"
                            >
                                <bo-svg
                                    :svg-content="'/assets/graphics/img-email.svg'"
                                    :primary-color="primaryColor"
                                ></bo-svg>
                            </div>
                        </div>
                        <div
                            class="right-panel"
                            :class="{ 'pnpfood-panel': isPnpFood }"
                            v-if="
                                !(actionText == 'Open-Mail') &&
                                (actionText == 'Login' || actionText == 'Register' || actionText == 'Forget-Password')
                            "
                        >
                            <div
                                class="select-tab"
                                v-if="allowRegistration"
                            >
                                <div
                                    class="tab-class"
                                    :class="actionText == 'Login' ? 'active' : ''"
                                    :style="actionText == 'Login' ? `border-bottom-color: ${primaryColor}` : ''"
                                    @click="login"
                                >
                                    {{ loginTranslations.login ?? "Login" }}
                                </div>
                                <div
                                    class="tab-class"
                                    :class="actionText == 'Register' ? 'active' : ''"
                                    :style="actionText == 'Register' ? `border-bottom-color: ${primaryColor}` : ''"
                                    @click="register"
                                >
                                    {{ loginTranslations.register ?? "Register" }}
                                </div>
                            </div>

                            <div
                                class="welcome-panel"
                                ref="pnpWelcomePanel"
                                v-show="isPnpFood && (actionText == 'Login' || actionText == 'Register')"
                                :style="
                                    pnpWelcomePanelExpanded
                                        ? 'position: relative;'
                                        : `max-height: ${
                                              isMobileViewport ? '366px' : '262px'
                                          }; overflow: hidden; position: relative;`
                                "
                            >
                                <div
                                    id="welcome-subtitle"
                                    class="subtitle"
                                    style="font-weight: bold"
                                >
                                    <ul>
                                        <li>
                                            非餐飲批量訂購：請洽東遠的
                                            <a
                                                href="https://www.goodfoodyou.tw/"
                                                style="color: #007aff; font-weight: bold"
                                                >零售門市- 好歐食庫 Good Food You</a
                                            >
                                            選購。
                                        </li>
                                        </br>
                                        <li>
                                            新客採購：請先填寫<a
                                                href="https://pnpfood.fillout.com/application"
                                                style="color: #007aff; font-weight: bold"
                                                >註冊表單</a>，表單送出後3個工作天內開通，敬請留意您的註冊信箱。
                                        </li>
                                        </br >
                                        <li>
                                            舊客開通採購帳戶，請洽您專屬的東遠國際業務聯繫開通
                                        </li>
                                    </ul>
                                    </br>
                                    <ul>
                                        <li>
                                            Non-Foodservice Bulk Orders:</br >Please visit
                                            <a
                                                href="https://www.goodfoodyou.tw/"
                                                style="color: #007aff; font-weight: bold"
                                                >Good Food You Gourmet Shop</a
                                            >, for purchases.
                                        </li>
                                        </br>
                                        <li>
                                            New Customers – Business Purchasing:</br >Please complete the
                                            <a
                                                href="https://pnpfood.fillout.com/eng-register"
                                                style="color: #007aff; font-weight: bold"
                                                >Registration Form</a
                                            >
                                            first. After submission and approval, your business account will be
                                            activated within approximately 3 business days. Please check your
                                            registered email for the account activation notice.
                                        </li>
                                        </br>
                                        <li>
                                            Existing Customers – Business Account Activation:</br>Please contact your
                                            dedicated P&amp;P Food sales representative for assistance with activating
                                            your business purchasing account.
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-if="
                                        (actionText == 'Login' || actionText == 'Register') &&
                                        !pnpWelcomePanelExpanded &&
                                        pnpWelcomePanelOverflows
                                    "
                                    class="overlay"
                                >
                                    <button
                                        type="button"
                                        class="btn-expand"
                                        @click="pnpWelcomePanelExpanded = true"
                                    >
                                        <i class="icon icon-chevronleft"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="subtitle">{{ loginTranslations.email ?? "Email" }}</div>
                                <input
                                    v-model="email"
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    :placeholder="loginTranslations.email_placeholder ?? 'Eg. username@email.com'"
                                    required
                                />
                                <div
                                    v-if="alert1"
                                    class="alert-message"
                                    role="alert"
                                >
                                    <i class="icon-cancelcircle-1"></i>
                                    {{ message }}
                                </div>
                            </div>
                            <div
                                class="form-group"
                                v-if="actionText == 'Register'"
                            >
                                <label>{{ loginTranslations.phone ?? "Phone" }}</label>
                                <div class="input-group">
                                    <div class="dropdown">
                                        <button
                                            type="button"
                                            class="form-control dropdown-toggle"
                                            data-toggle="dropdown"
                                            :aria-expanded="false"
                                        >
                                            {{ selectedCountry }}
                                        </button>
                                        <div
                                            class="dropdown-menu shadow-sm overflow-auto w-auto p-0"
                                            style="max-height: 200px"
                                        >
                                            <div
                                                v-for="(code, country) in countries"
                                                :key="country"
                                                class="dropdown-item d-flex justify-content-between px-3 py-2"
                                                @click="selectedCountry = code"
                                            >
                                                <span class="text-left">{{ country }}</span>
                                                <span class="text-right text-muted ms-2">{{ code }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <input
                                        v-model="phone"
                                        type="tel"
                                        class="form-control"
                                        id="phone"
                                        :placeholder="loginTranslations.phone_placeholder ?? 'Eg. 123456789'"
                                        required
                                    />
                                </div>
                                <div
                                    v-if="alert3"
                                    class="alert-message"
                                    role="alert"
                                >
                                    <i class="icon-cancelcircle-1"></i>
                                    {{ message }}
                                </div>
                            </div>
                            <div
                                class="form-group input-password"
                                v-if="actionText == 'Login'"
                            >
                                <div class="subtitle">{{ loginTranslations.password ?? "Password" }}</div>
                                <div class="password-container">
                                    <input
                                        v-model="password"
                                        :type="showPassword ? 'text' : 'password'"
                                        class="form-control"
                                        id="password_login"
                                        :placeholder="loginTranslations.password_placeholder ?? 'Enter Password'"
                                        required
                                    />
                                    <div
                                        @click="togglePasswordVisibility"
                                        class="toggle-password"
                                    >
                                        <i :class="showPassword ? 'icon-visibility' : 'icon-visibilityoff'"></i>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                                    <div
                                        v-if="alert4"
                                        class="alert-message"
                                        role="alert"
                                        style="margin: 0"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ message }}
                                    </div>
                                    <div
                                        class="subtitle forget-password theme-primary-color"
                                        style="padding-top: 0; margin-left: auto"
                                    >
                                        <span @click="forgetPassword">
                                            {{ loginTranslations.reset_password ?? "Reset Password" }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="form-group input-password"
                                v-if="actionText == 'Register'"
                            >
                                <label>{{ loginTranslations.password ?? "Password" }}</label>
                                <div class="password-container">
                                    <input
                                        v-model="register_password"
                                        :type="showRegisterPassword ? 'text' : 'password'"
                                        class="form-control"
                                        id="register_password"
                                        :placeholder="loginTranslations.password_placeholder ?? 'Enter Password'"
                                        required
                                    />
                                    <div
                                        @click="toggleRegisterPasswordVisibility"
                                        class="toggle-password"
                                    >
                                        <i :class="showRegisterPassword ? 'icon-visibility' : 'icon-visibilityoff'"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="forget-password">
                            <label
                                v-if="actionText == 'Login'"
                                class="theme-primary-color"
                                @click="forgetPassword"
                                >Reset Password</label
                            >
                        </div> -->
                            <div
                                class="form-group input-password"
                                v-if="actionText == 'Register'"
                            >
                                <label>{{ loginTranslations.confirm_password ?? "Confirm Passowrd" }}</label>
                                <div class="password-container">
                                    <input
                                        v-model="register_password_confirm"
                                        :type="showConfirmPassword ? 'text' : 'password'"
                                        class="form-control"
                                        id="confirm_password"
                                        name="confirm_password"
                                        :placeholder="loginTranslations.password_placeholder ?? 'Enter Password'"
                                        required
                                    />
                                    <div
                                        @click="toggleConfirmPasswordVisibility"
                                        class="toggle-password"
                                    >
                                        <i :class="showConfirmPassword ? 'icon-visibility' : 'icon-visibilityoff'"></i>
                                    </div>
                                </div>
                                <div
                                    v-if="alert2"
                                    class="alert-message"
                                    role="alert"
                                >
                                    <i class="icon-cancelcircle-1"></i>
                                    {{ message }}
                                </div>
                            </div>
                            <!-- <div v-if="actionText == 'Reset-Password'">
                            <div class="form-group">
                                <label>New Password</label>
                            </div>
                            <div class="form-group">
                                <label>Repeat New Password</label>
                            </div>
                        </div> -->

                            <div class="form-footer">
                                <!-- <slot name="button"></slot> -->
                                <button
                                    v-if="actionText == 'Forget-Password'"
                                    type="button"
                                    class="footer-btn light"
                                    @click="login"
                                >
                                    {{ generalTranslations.cancel ?? "Cancel" }}
                                </button>

                                <button
                                    type="button"
                                    class="footer-btn"
                                    v-if="actionText !== null && actionText != 'Open-Mail'"
                                    :disabled="disabled"
                                    @click="triggerAction"
                                >
                                    {{ submitButtonText }}
                                </button>
                            </div>

                            <div
                                v-if="notFound"
                                class="alert alert-danger"
                                role="alert"
                            >
                                {{ message }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);
import Vue from "vue";
import { showPageLoading, hidePageLoading } from "@/v2/utils/page-loading.js"; // #111741: never clear the shared veil by hand
import vClickOutside from "v-click-outside";
import api from "../../api";
import setAuthToken from "js/token";
import { parsePhoneNumberFromString } from "libphonenumber-js";
Vue.use(vClickOutside);
export default {
    props: {
        id: {
            type: String,
            default: "",
        },
        modalName: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        modalStyle: {
            type: String,
            default: "",
        },
        action: {
            type: String,
            default: "",
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        noTitle: {
            type: Boolean,
            default: false,
        },
        fade: {
            type: Boolean,
            default: true,
        },
        allowRegistration: {
            type: Boolean,
            default: false,
        },
    },
    created: function () {},
    computed: {},
    data() {
        return {
            isMobileViewport:
                typeof window.matchMedia === "function" && window.matchMedia("(max-width: 768px)").matches,
            primaryColor: window.bo_primary_color || "#594c45",
            actionText: this.action,
            titleText: this.title,
            visible: this.active,
            submitButtonText: window.bo?.loginTranslations?.login ?? "Login",
            notFound: false,
            alert1: false,
            alert2: false,
            alert3: false,
            alert4: false,
            email: "",
            password: "",
            phone: "",
            selectedCountry: window.bo?.selectedCountryCode ?? "+60",
            // phoneError: '',
            countries: {
                Malaysia: "+60",
                Singapore: "+65",
                Taiwan: "+886",
                Japan: "+81",
            },
            register_password: "",
            register_password_confirm: "",
            url: document.getElementsByName("url")[0].getAttribute("content"),
            outletId: document.getElementsByName("outlet")
                ? document.getElementsByName("outlet")[0]?.getAttribute("content")
                : null,
            message: window.bo?.loginTranslations?.invalid_details ?? "Invalid Password/ Email",
            checkValidate: false,
            siteLogoUrl: window.bo.siteLogoUrl,
            showPassword: false,
            showRegisterPassword: false,
            showConfirmPassword: false,
            generalTranslations: window.bo?.generalTranslations ?? {},
            loginTranslations: window.bo?.loginTranslations ?? {},
            isPnpFood: window.bo?.isPnpFood ?? false,
            pnpWelcomePanelExpanded: false,
            pnpWelcomePanelOverflows: false,
        };
    },
    watch: {
        active: function (n, o) {
            this.visible = n;
            if (n) {
                this.resetState();
            }
        },
    },
    mounted() {
        // add event listener on bootstrap modal close
        $(`#${this.id}`).on("hidden.bs.modal", () => {
            this.actionText = "Login";
            this.titleText = window.bo?.loginTranslations?.login ?? "Login";
            this.submitButtonText = window.bo?.loginTranslations?.login ?? "Login";
        });
        this.$nextTick(() => {
            const el = this.$refs.pnpWelcomePanel;
            if (el) {
                this.pnpWelcomePanelOverflows = el.scrollHeight > el.clientHeight;
            }
        });
        this._resizeHandler = () => {
            this.isMobileViewport =
                typeof window.matchMedia === "function" && window.matchMedia("(max-width: 768px)").matches;
            this.$nextTick(() => {
                const el = this.$refs.pnpWelcomePanel;
                if (el) {
                    this.pnpWelcomePanelOverflows = el.scrollHeight > el.clientHeight;
                }
            });
        };
        window.addEventListener("resize", this._resizeHandler);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this._resizeHandler);
    },
    methods: {
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleRegisterPasswordVisibility() {
            this.showRegisterPassword = !this.showRegisterPassword;
        },
        toggleConfirmPasswordVisibility() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        activate() {
            this.visible = true;
            this.$emit("activate");
        },
        deactivate: function () {
            // Do not use visible with bootstrap modal
            // Now use bootstrap modal only
            $(`#${this.id}`).modal("hide");
        },
        triggerAction() {
            if (this.actionText == "Login") {
                this.postlogin();
            } else if (this.actionText == "Forget-Password") {
                this.postForgetPassword();
            } else {
                this.postRegister();
            }
            this.$emit("trigger");
        },
        register() {
            var form = document.getElementById("post-form");
            form.classList.remove("was-validated");
            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.phone = "";
            // this.password = "";
            this.register_password = "";
            this.register_password_confirm = "";
            this.actionText = "Register";
            this.titleText = window.bo?.loginTranslations?.register ?? "Register";
            this.submitButtonText = window.bo?.loginTranslations?.confirm ?? "Confirm";
        },
        login() {
            var form = document.getElementById("post-form");
            form.classList.remove("was-validated");
            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.password = "";
            this.actionText = "Login";
            this.titleText = window.bo?.loginTranslations?.login ?? "Login";
            this.submitButtonText = window.bo?.loginTranslations?.login ?? "Login";
        },
        forgetPassword() {
            this.notFound = false;
            this.actionText = "Forget-Password";
            this.titleText = "";
            this.submitButtonText = window.bo?.loginTranslations?.send ?? "Send";
        },
        openMail() {
            this.notFound = false;
            this.actionText = "Open-Mail";
            this.titleText = "";
            this.submitButtonText = window.bo?.generalTranslations?.cancel ?? "Cancel";
        },
        resetPassword() {
            this.actionText = "Reset-Password";
            this.titleText = "";
            this.submitButtonText = window.bo?.loginTranslations?.reset_password ?? "Reset Password";
        },
        resetState() {
            this.$nextTick(() => {
                var form = document.getElementById("post-form");
                if (form) {
                    form.classList.remove("was-validated");
                }
                const emailInput = document.getElementById("email");
                if (emailInput) {
                    emailInput.classList.remove("is-invalid", "is-valid");
                }
                const phoneInput = document.getElementById("phone");
                if (phoneInput) {
                    phoneInput.classList.remove("is-invalid", "is-valid");
                }
                const confirmPasswordInput = document.getElementById("confirm_password");
                if (confirmPasswordInput) {
                    confirmPasswordInput.classList.remove("is-invalid", "is-valid");
                    confirmPasswordInput.value = "";
                }
                const registerPasswordInput = document.getElementById("register_password");
                if (registerPasswordInput) {
                    registerPasswordInput.classList.remove("is-invalid", "is-valid");
                }
                const passwordLoginInput = document.getElementById("password_login");
                if (passwordLoginInput) {
                    passwordLoginInput.classList.remove("is-invalid", "is-valid");
                }
            });

            this.notFound = false;
            this.alert1 = false;
            this.alert2 = false;
            this.alert3 = false;
            this.alert4 = false;
            this.email = "";
            this.password = "";
            this.phone = "";
            this.register_password = "";
            this.register_password_confirm = "";
            this.showPassword = false;
            this.showRegisterPassword = false;
            this.showConfirmPassword = false;
            this.actionText = this.action || "Login";
            this.titleText =
                this.title ||
                (this.actionText == "Register"
                    ? window.bo?.loginTranslations?.register ?? "Register"
                    : window.bo?.loginTranslations?.login ?? "Login");
            this.submitButtonText =
                this.buttonText ||
                (this.actionText == "Register"
                    ? window.bo?.loginTranslations?.confirm ?? "Confirm"
                    : window.bo?.loginTranslations?.login ?? "Login");
            this.message = window.bo?.loginTranslations?.invalid_details ?? "Invalid Password/ Email";
        },
        validateEmail(mail) {
            var form = document.getElementById("post-form");
            if (mail == "") {
                this.message = this.loginTranslations.email_empty_error ?? "The email address cannot be empty!";
                form.classList.remove("was-validated");
                document.getElementById("email").classList.add("is-invalid");
                this.alert1 = true;
                this.alert2 = false;
                this.alert3 = false;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            var lastAtPos = mail.lastIndexOf("@");
            var lastDotPos = mail.lastIndexOf(".");
            var emailFormatPassed;
            emailFormatPassed =
                lastAtPos < lastDotPos &&
                lastAtPos > 0 &&
                mail.indexOf("@@") == -1 &&
                lastDotPos > 2 &&
                mail.length - lastDotPos > 2;

            if (emailFormatPassed) {
                document.getElementById("email").classList.remove("is-invalid");
                this.alert1 = false;
                this.notFound = false;
                this.checkValidate = true;
                return true;
            }
            this.message = window.bo?.loginTranslations?.invalid_email ?? "Invalid email";
            form.classList.remove("was-validated");
            document.getElementById("email").classList.add("is-invalid");
            this.alert1 = true;
            this.alert2 = false;
            this.alert3 = false;
            this.notFound = false;
            this.checkValidate = false;
            return false;
        },
        validatePhone() {
            var form = document.getElementById("post-form");
            const input = document.getElementById("phone");
            input.classList.remove("is-invalid", "is-valid");

            if (!this.phone) {
                this.message = this.loginTranslations.phone_empty_error ?? "The phone number cannot be empty!";
                form.classList.remove("was-validated");
                input.classList.add("is-invalid");
                this.alert1 = false;
                this.alert2 = false;
                this.alert3 = true;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            const countryMap = {
                "+60": "MY",
                "+65": "SG",
                "+886": "TW",
                "+81": "JP",
            };

            const countryCode = countryMap[this.selectedCountry];

            const phoneNumber = parsePhoneNumberFromString(this.phone, countryCode);
            if (!phoneNumber || !phoneNumber.isValid()) {
                this.message = this.loginTranslations.invalid_phone ?? "Invalid phone number";
                form.classList.remove("was-validated");
                input.classList.add("is-invalid");
                this.alert1 = false;
                this.alert2 = false;
                this.alert3 = true;
                this.notFound = false;
                this.checkValidate = false;
                return false;
            }

            this.validatedPhone = phoneNumber;
            this.message = "";
            input.classList.add("is-valid");
            this.alert3 = false;
            this.notFound = false;
            this.checkValidate = true;
            return true;
        },

        postlogin: function () {
            showPageLoading();

            var form = document.getElementById("post-form");
            form.classList.add("was-validated");

            if (!this.validateEmail(document.getElementById("email").value)) {
                hidePageLoading();
                document.getElementById("email").classList.add("is-invalid");
                return;
            }
            if ($("#password_login").val() == "") {
                hidePageLoading();
                document.getElementById("password_login").classList.add("is-invalid");
                this.alert4 = true;
                this.message = this.loginTranslations.password_empty_error ?? "The password cannot be empty!";
                this.checkValidate = false;
                return;
            }

            if (form.checkValidity()) {
                this.apiLogin();
                form.classList.remove("was-validated");
            }

            hidePageLoading();
        },
        apiLogin: function () {
            this.notFound = false;
            this.alert4 = false;
            var that = this;
            api.post(this.url + "/login", {
                baseUrl: this.url,
                email: this.email,
                password: this.password,
            })
                .then((response) => {
                    if (response.status == 200) {
                        // that.visible = false;
                        // Do not use visible with bootstrap modal
                        // Now use bootstrap modal only
                        this.isSuccessLogin = true;
                        this.deactivate();
                        setAuthToken(response.data.token);
                        alert(window.bo?.loginTranslations?.login_successful ?? "Login Successful");
                        window.location.href = response.data.url;
                    } else {
                        that.alert4 = true;
                        this.message = window.bo?.loginTranslations.api_error ?? "Something Wrong happened";
                    }
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.alert4 = true;
                    const status = error?.response?.status;
                    if (status === 429) {
                        that.message =
                            that.loginTranslations.too_many_login_attempts ??
                            "Too many login attempts. Please wait a minute and try again.";
                    } else if (status === 401) {
                        that.message = that.loginTranslations.invalid_details ?? "Invalid Password/ Email";
                    } else {
                        that.message = that.loginTranslations.api_error ?? "Something went wrong, please try again.";
                    }
                });
        },

        postRegister: function () {
            var form = document.getElementById("post-form");
            form.classList.add("was-validated");

            if (
                document.getElementById("register_password").value != document.getElementById("confirm_password").value
            ) {
                form.classList.remove("was-validated");
                document.getElementById("register_password").classList.add("is-invalid");
                document.getElementById("confirm_password").classList.add("is-invalid");
                this.message = window.bo?.loginTranslations?.password_mismatch ?? "Password Mismatch";
                this.alert1 = false;
                this.alert2 = true;
                this.alert3 = false;
                this.notFound = false;
            } else if (this.validateEmail(document.getElementById("email").value)) {
                if (this.validatePhone()) {
                    this.alert1 = false;
                    this.alert2 = false;
                    this.alert3 = false;
                    this.alert4 = false;
                    this.notFound = false;
                    this.apiRegister();
                    document.getElementById("register_password").classList.remove("is-invalid");
                    document.getElementById("confirm_password").classList.remove("is-invalid");
                    showPageLoading();
                    form.classList.remove("was-validated");
                }
            }
        },

        apiRegister: function () {
            var that = this;
            api.post(this.url + "/register", {
                baseUrl: this.url,
                email: this.email,
                phone: this.validatedPhone,
                password: this.register_password,
                outletId: this.outletId,
            })
                .then((response) => {
                    hidePageLoading();
                    if (response.status == 200) {
                        $("#hideModal").trigger("click");
                        that.alert1 = false;
                        that.alert2 = false;
                        that.alert3 = false;
                        that.alert4 = false;
                        that.notFound = false;
                        that.message = "";
                        that.showRegisterPassword = false;
                        that.showConfirmPassword = false;
                        alert(
                            that.loginTranslations.congrat_registration_successful ?? response.data.message,
                            this.loginTranslations.registration_successful ?? "Registration Successful"
                        );
                        this.email = "";
                        this.phone = "";
                        this.register_password = "";
                        this.register_password_confirm = "";
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.message = error.response.data?.error;
                    that.alert1 = false;
                    that.alert2 = false;
                    that.alert3 = false;
                    that.notFound = false;
                    if (that.message.includes("email")) {
                        that.message =
                            that.loginTranslations.email_exist_error ?? "An account with this email already exists.";
                        document.getElementById("email").classList.add("is-invalid");
                        that.alert1 = true;
                    } else if (that.message.includes("phone")) {
                        that.message =
                            that.loginTranslations.phone_exist_error ?? "An account with this phone already exists.";
                        document.getElementById("phone").classList.add("is-invalid");
                        that.alert3 = true;
                    } else {
                        that.notFound = true;
                        that.message = that.loginTranslations.api_error ?? "Something wrong happened";
                    }
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    }
                });
        },

        postForgetPassword: function () {
            showPageLoading();
            var form = document.getElementById("post-form");
            form.classList.add("was-validated");
            if (form.checkValidity()) {
                this.apiForgetPassword();
                form.classList.remove("was-validated");
            } else {
                hidePageLoading();
            }
        },

        apiForgetPassword: function () {
            this.notFound = false;
            var that = this;
            var postUrl = this.url + "/forgot-password";
            api.post(postUrl, {
                email: this.email,
            })
                .then((response) => {
                    if (response.data.status == 200) {
                        this.openMail();
                    } else {
                        this.message = response.data.message;
                        this.notFound = true;
                    }
                    hidePageLoading();
                })
                .catch(function (error) {
                    hidePageLoading();
                    that.loggingIn = false;
                    that.notFound = true;
                    if (error?.response?.status === 429) {
                        that.message =
                            that.loginTranslations.too_many_reset_requests ??
                            "Too many reset requests. Please wait a few minutes and try again.";
                    } else {
                        that.message = that.loginTranslations.api_error ?? "Something went wrong, please try again.";
                    }
                });
        },
    },
};
</script>
